import { jsx as _jsx } from "react/jsx-runtime";
import { SectionList } from "native-base";
import { useState } from "react";
import { useWindowDimensions } from "react-native";
import InsulinMeasurementListItem from "../../molecules/ListItem/InsulinMeasurementListItem";
const DashboardInsulinMeasurementContentMobile = ({ sections }) => {
    const [flatListPosition, setFlatListPosition] = useState(0);
    const screenHeight = useWindowDimensions().height;
    return (_jsx(SectionList, { onLayout: (event) => {
            setFlatListPosition(event.nativeEvent.layout.y);
        }, maxHeight: screenHeight - flatListPosition - 4, width: "full", minWidth: "full", showsVerticalScrollIndicator: false, sections: [{ data: sections }], renderItem: ({ item }) => (_jsx(InsulinMeasurementListItem, Object.assign({}, item, { editable: false, onDeletePress: () => console.log("delete") }))), keyExtractor: (item, index) => `section-list-item-${index}`, stickySectionHeadersEnabled: true }));
};
export default DashboardInsulinMeasurementContentMobile;
